import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(
  ({ spacing }) => ({
    root: {
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'baseline',
      margin: spacing(0, -1),
      flexWrap: 'wrap',
    },
  }),
  { name: 'LinkItem' },
);

export default useStyles;
